import ApiService from "@/common/api.service";
import { COMPANY_ID } from "@/common/config.js";
import { GET_SHIPPING_NOODLE, GET_SHIPPING_GOODS } from "./actions.type";
import {
  SET_SHIPPING_NOODLE,
  SET_SHIPPING_GOODS,
  SET_SHIPPING_ERROR
} from "./mutations.type";

const state = {
  noodle: null,
  goods: null,
  error: null
};
const getters = {
  shippingNoodle(state) {
    return state.noodle;
  },
  shippingGoods(state) {
    return state.goods;
  }
};

const actions = {
  [GET_SHIPPING_NOODLE]({ rootState, commit }, payload) {
    if (payload.size === 0) {
      return;
    }
    const prefectureData = rootState.order.prefectureData;
    const prefectureID = prefectureData.find((o) => o.name === payload.address);
    ApiService.get(
      "v1/shippings",
      `shipping_free?company_id=${COMPANY_ID}&prefecture_id=${prefectureID.id}&size=${payload.size}&type=冷蔵`
    )
      .then((response) => {
        commit(SET_SHIPPING_NOODLE, response.data);
        commit(SET_SHIPPING_ERROR, null);
      })
      .catch((response) => {
        commit(SET_SHIPPING_ERROR, response.data);
      });
  },
  [GET_SHIPPING_GOODS]({ rootState, commit }, payload) {
    if (payload.size === 0) {
      return;
    }

    const prefectureData = rootState.order.prefectureData;
    const prefectureID = prefectureData.find((o) => o.name === payload.address);
    ApiService.get(
      "v1/shippings",
      `shipping_free?company_id=${COMPANY_ID}&prefecture_id=${prefectureID.id}&size=${payload.size}&type=常温`
    )
      .then((response) => {
        commit(SET_SHIPPING_GOODS, response.data);
        commit(SET_SHIPPING_ERROR, null);
      })
      .catch((response) => {
        commit(SET_SHIPPING_ERROR, response.data);
      });
  }
};

const mutations = {
  [SET_SHIPPING_NOODLE](state, payload) {
    state.noodle = payload;
  },
  [SET_SHIPPING_GOODS](state, payload) {
    state.goods = payload;
  },
  [SET_SHIPPING_ERROR](state, payload) {
    state.error = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
